import React from "react";
import { IBlock } from "../../database";

type BlocksListProps = {
	blocks: IBlock[];
	viewBlock: (block: IBlock) => void;
};

const BlocksList: React.FC<BlocksListProps> = ({ blocks, viewBlock }) => {
	return (
		<div>
			{blocks.map((block) => (
				<p
					style={{ color: "black", fontSize: 18, cursor: "pointer" }}
					key={block.blockId}
					onClick={() => viewBlock(block)}
				>
					{block.name}
				</p>
			))}
		</div>
	);
};

export default BlocksList;
